import {
  SET_TRATO_CONFIGURADOR,
  SET_NOMBRE_CONFIGURADOR,
  SET_APELLIDO_MATERNO_CONFIGURADOR,
  SET_APELIIDO_PATERNO_CONFIGURADOR,
  SET_ESTADO_CONFIGURADOR,
  SET_CIUDAD_CONFIGURADOR,
  SET_ID_CONCESIONARIO_CONFIGURADOR,
  SET_CONCESIONARIO_CONFIGURADOR,
  SET_TELEFONO_CONFIGURADOR,
  SET_MOVIL_CONFIGURADOR,
  SET_CORREO_CONFIGURADOR,
  SET_COMENTARIOS_CONFIGURADOR,
  SET_AVISO_PRIVACIDAD_CONFIGURADOR,
  SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR,
  SET_DATOS_1_CONFIGURADOR,
  SET_DATOS_2_CONFIGURADOR,
  SET_MODEL_INFO_CONFIGURADOR,
  RESET_STATE_CONFIGURADOR,
} from "../types";

const initialState = {
  trato: "Sr",
  nombre: "",
  apellidoPaterno: "",
  apellidoMaterno: "",
  correo: "",
  telefono: "",
  movil: "",
  estado: "",
  ciudad: "",
  idConcesionario: "",
  concesionario: "",
  comentarios: "",
  avisoPrivacidad: false,
  terminosCondiciones: false,
  datos1: false,
  datos2: false,
  modelinfo: null
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATO_CONFIGURADOR:
      return {
        ...state,
        trato: action.payload,
      };
    case SET_NOMBRE_CONFIGURADOR:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_MATERNO_CONFIGURADOR:
      return {
        ...state,
        apellidoMaterno: action.payload,
      };
    case SET_APELIIDO_PATERNO_CONFIGURADOR:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_CONFIGURADOR:
      return {
        ...state,
        estado: action.payload,
      };
    case SET_CIUDAD_CONFIGURADOR:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_CONFIGURADOR:
      return {
        ...state,
        idConcesionario: action.payload,
      };
    case SET_CONCESIONARIO_CONFIGURADOR:
      return {
        ...state,
        concesionario: action.payload,
      };
    case SET_TELEFONO_CONFIGURADOR:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_CONFIGURADOR:
      return {
        ...state,
        movil: action.payload,
      };
    case SET_CORREO_CONFIGURADOR:
      return {
        ...state,
        correo: action.payload,
      };
    case SET_COMENTARIOS_CONFIGURADOR:
      return {
        ...state,
        comentarios: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_CONFIGURADOR:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_CONFIGURADOR:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_DATOS_1_CONFIGURADOR:
      return {
        ...state,
        datos1: action.payload,
      };
    case SET_DATOS_2_CONFIGURADOR:
      return {
        ...state,
        datos2: action.payload,
      };
    case SET_MODEL_INFO_CONFIGURADOR:
      return {
        ...state,
        modelinfo: action.payload,
      };
    case RESET_STATE_CONFIGURADOR:
      return initialState;
    default:
      return state;
  }
}
